import { getUserAttributes } from './../../services/api-user-attributes.service';
import { useQuery } from 'react-query';
const GET_USER_ATTRIBUTES = 'get_user_attributes';

export const useUserAttributes = (userId: string) =>
  useQuery([GET_USER_ATTRIBUTES, userId], () => getUserAttributes({ userId }));
